module.exports = __webpack_public_path__ + "static/media/after.7a220d76.png";